import React, { ReactNode } from 'react';
import { Chit, ChitContent, ChitMain, ChitAvatar, ChitText, ChitArrow } from 'src/components/ui/chit';

interface SettingsCardProps {
  title: string;
  description: string;
  icon: ReactNode;
  onClick: () => void;
  dangerous?: boolean;
}

export const SettingsCard: React.FC<SettingsCardProps> = ({
  title,
  description,
  icon,
  onClick,
  dangerous = false
}) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <Chit 
      variant={dangerous ? 'dangerous' : 'default'}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <ChitContent>
        <ChitMain>
          <ChitAvatar icon={icon} />
          <ChitText 
            title={title}
            description={description}
            titleClassName={dangerous ? 'text-red-400' : undefined}
            descriptionClassName={dangerous ? 'text-red-400/70' : undefined}
          />
        </ChitMain>
        <ChitArrow className={dangerous ? 'text-red-400/70' : undefined} />
      </ChitContent>
    </Chit>
  );
};